import { Container } from "reactstrap";
import Overview from "./Overview/Overview";
import FeeExplanation from "./FeeExplanation/FeeExplanation";
import HistoricalDataAndTrends from "./HistoricalDataAndTrends/HistoricalDataAndTrends";
import FeeNegotiation from "./FeeNegotiation/FeeNegotiation";

const FeeBreakdown = () => {
  return (
    <div
      style={{
        background: "#f2f2f2",
        minHeight: "100dvh",
        padding: "20px",
      }}
    >
      <Container fluid className="p-0">
        <h4 className="fw-semibold mb-3">Fee and Charge Breakdown</h4>
        <Overview />
        <FeeExplanation />
        <HistoricalDataAndTrends />
        <FeeNegotiation />
      </Container>
    </div>
  );
};

export default FeeBreakdown;